import React, { useState, useEffect, useCallback } from "react";
import {
  Grid,
  Button,
  Typography,
  Modal,
  Box,
  styled,
  IconButton,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Headerbar from "../../components/headerbar/Headerbar";
import SearchIcon from "@mui/icons-material/Search";
import { debounce } from "lodash";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import SimpleDialog from "../../components/dialog/dialog";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
// import ConfirmModal from "../../components/ConfirmModal/ConfirmModal";
import AddUserModal from "../../components/modals/adduser/AddUserModal";
import EditNoteIcon from "@mui/icons-material/EditNote";
import EditUserModal from "../../components/modals/edituser/EditUserModal";
import {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
} from "../../../services/api/axios_api_Request";
import { toast } from "react-toastify";
import appLogo from "../../../../src/assets/images/man-cogwheel.png";
import clientLogo from "../../../../src/assets/images/icons8-company-48.png";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import Tooltip from "@mui/material/Tooltip";
import "./user-control.scss";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useNavigate } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const getStyles = (name, selectedApps = [], theme) => ({
  fontWeight:
    selectedApps.indexOf(name) === -1
      ? theme.typography.fontWeightRegular
      : theme.typography.fontWeightMedium,
});

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, Arial, sans-serif",
  },
});

const GreyButton = styled(Button)(({ theme }) => ({
  color: "grey",
  borderColor: "grey",
  "&:hover": {
    borderColor: "darkgrey",
  },
}));

const UserControl = () => {
  const [userData, setUserData] = useState([]);
  const [userRoleName, setUserRoleName] = useState(""); // State to hold userRoleName
  const [appData, setAppData] = useState([]); // State to store app names
  const [selectedRows, setSelectedRows] = useState([]);
  const [addUserOpen, setAddUserOpen] = useState(false);
  const [editUserOpen, setEditUserOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUserData, setFilteredUserData] = useState([]);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [clickedUser, setClickedUser] = useState({});
  const [deleteModalOpen, setDeleteModalOpen] = useState(false); // Corrected delete modal state
  const [clearedAppData, setClearedAppData] = useState(false); // Track if clearAllAppData() is executed
  const [isSuperSuperAdmin, setIsSuperSuperAdmin] = useState(false);
  const [activateUserId, setActivateUserId] = useState(null);
  const [activateModalOpen, setActivateModalOpen] = useState(false);
  const navigate = useNavigate();

  // Callback function to update the state from the child
  const handleUserRoleNameChange = (roleName) => {
    setUserRoleName(roleName);
  };

  const handleGoBack = () => {
    navigate("/applications"); // Navigate to /applications
  };

  const fetchUserData = async () => {
    setLoading(true);
    try {
      const res = await getRequest("/admin/users");
      if (res?.status === 200) {
        const users = res?.data?.users || [];

        setUserData(users);
        setFilteredUserData(users);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  };
  console.log("userdata", userData);

  const fetchApplications = async () => {
    try {
      const res = await getRequest("/admin/applications");
      if (res?.status === 200) {
        const applications = res?.data?.applications || [];
        console.log("Fetched applications from API - pravin:", applications);

        // Map using the correct property names 'app_id' and 'app_name'
        const appNamesWithIds = applications.map((app) => {
          if (app && app.app_id && app.app_name) {
            return {
              app_id: app.app_id, // Correct property name
              app_name: app.app_name, // Correct property name
            };
          } else {
            console.warn(
              "Application without a valid app_name or app_id property found:",
              app
            );
            return {
              app_id: "Unknown ID", // Fallback for apps without an app_id
              app_name: "Unknown App", // Fallback for apps without an app_name
            };
          }
        });

        // Assuming you set appData state here
        setAppData(appNamesWithIds);
      }
    } catch (error) {
      console.error("Error fetching applications:", error);
    }
  };

  //Logout Functionality
  function clearAllAppData() {
    if (!clearedAppData) {
      // Clear cookies
      document.cookie.split(";").forEach((cookie) => {
        const name = cookie.split("=")[0].trim();
        let domain = "";

        if (
          process.env.REACT_APP_ENV === "production" ||
          process.env.REACT_APP_ENV === "test"
        ) {
          // Production & Test environment
          domain = "; domain=.pharmaaceapps.com";
        }

        document.cookie =
          name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/" + domain;
      });

      localStorage.clear();
      sessionStorage.clear();

      // Clear IndexedDB
      indexedDB.databases().then((databases) => {
        databases.forEach((db) => {
          indexedDB.deleteDatabase(db.name);
        });
      });

      setClearedAppData(true); // Ensure this runs only once
    }
  }

  const checkAuthentication = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_LOGIN_APP}/auth/check-token`,
        {
          method: "GET",
          credentials: "include", // Include cookies in the request
        }
      );

      if (response.ok) {
        // stay on ApplicationPage page
      } else {
        clearAllAppData();
        navigate("/login");
        console.error("Not Logged in");
      }
    } catch (error) {
      clearAllAppData();
      console.error("Error during logout:", error);
    }
  };

  const fetchLoggedInUserDetails = async () => {
    try {
      const res = await getRequest("/auth/user-details");
      if (res?.status === 200) {
        const flag = res?.data?.is_super_super_admin;
        setIsSuperSuperAdmin(flag === true || flag === 1);
      }
    } catch (error) {
      console.error("Error fetching logged-in user details:", error);
    }
  };

  useEffect(() => {
    checkAuthentication();
    fetchLoggedInUserDetails();
    fetchApplications();
    fetchUserData();
    // console.log(userData);
  }, []);

  const confirmDeleteUser = async () => {
    if (!deleteUserId) {
      toast.error("User ID is missing. Unable to delete user.");
      return;
    }

    try {
      const res = await deleteRequest("/admin/delete-user", deleteUserId);

      // Checking if the request was successful
      if (res?.status === 200) {
        toast.success("User deactivated successfully.");
        // Fetch the updated user list after deletion
        await fetchUserData();
      } else {
        const errorMessage = res?.data?.error || "Failed to delete user";
        toast.error(errorMessage);
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.error ||
        error.message ||
        "An unexpected error occurred";
      console.error("Error deleting user:", errorMsg);
      toast.error(`Error: ${errorMsg}`);
    } finally {
      // Reset modal and user ID state
      setDeleteModalOpen(false);
      setDeleteUserId(null);
    }
  };

  const confirmActivateUser = async () => {
    if (!activateUserId) {
      toast.error("User ID is missing. Unable to activate user.");
      return;
    }

    try {
      const res = await postRequest("/admin/activate-user", { id: activateUserId });

      if (res?.status === 200) {
        toast.success("User activated successfully.");
        await fetchUserData();
      } else {
        const errorMessage = res?.data?.error || "Failed to activate user";
        toast.error(errorMessage);
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.error ||
        error.message ||
        "An unexpected error occurred";
      console.error("Error activating user:", errorMsg);
      toast.error(`Error: ${errorMsg}`);
    } finally {
      setActivateModalOpen(false);
      setActivateUserId(null);
    }
  };

  const handleSearchChange = useCallback(
    debounce((newSearchTerm, userData, setFilteredUserData) => {
      const lowerCaseSearchTerm = String(newSearchTerm || "").toLowerCase();

      const filteredData = userData?.filter((user) => {
        const username = String(user.username || "").toLowerCase();
        const userId = String(user.user_id || "").toLowerCase();

        return (
          username.includes(lowerCaseSearchTerm) ||
          userId.includes(lowerCaseSearchTerm)
        );
      });

      setFilteredUserData(filteredData);
    }, 500),
    []
  );

  const onInputChange = (e) => {
    const newSearchTerm = e.target.value || "";
    console.log("pravin search:", newSearchTerm); // for search input
    setSearchTerm(newSearchTerm);

    // Call the debounced search function
    handleSearchChange(newSearchTerm, userData, setFilteredUserData);
  };

  const handleAddUserOpen = () => setAddUserOpen(true);
  const handleEditUserOpen = (user) => {
    setClickedUser(user);
    setEditUserOpen(true);
  };
  const handleAddUserClose = () => setAddUserOpen(false);
  const handleEditUserClose = () => setEditUserOpen(false);

  const handleDeleteUserClick = (userId) => {
    setDeleteUserId(userId);
    setDeleteModalOpen(true);
  };

  const cancelDeleteUser = () => {
    setDeleteModalOpen(false);
    setDeleteUserId(null);
  };

  const handleActivateUserClick = (userId) => {
    setActivateUserId(userId);
    setActivateModalOpen(true);
  };

  const cancelActivateUser = () => {
    setActivateModalOpen(false);
    setActivateUserId(null);
  };
  // Define common styles outside of the renderCell
  const activeStyle = {
    backgroundColor: "#A6E7D8",
    border: "1px solid #008767",
    padding: "12px",
    height: "2rem",
    color: "#008767",
    wordBreak: "break-all",
    fontSize: "0.82rem",
    fontWeight: 400,
    borderRadius: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "150px",
    width: "120px",
  };
  const inactiveStyle = {
    backgroundColor: "#FFC5C5",
    border: "1px solid #DF0404",
    padding: "6px",
    height: "2rem",
    color: "#DF0404",
    wordBreak: "break-all",
    fontSize: "0.82rem",
    fontWeight: 400,
    borderRadius: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "150px",
    width: "120px",
  };
  const roleStyle = {
    backgroundColor: "#CCEAFF",
    border: "1px solid #006CB8",
    padding: "4px 6px",
    height: "2rem",
    color: "#006CB8",
    wordBreak: "break-all",
    fontSize: "0.82rem",
    fontWeight: 400,
    borderRadius: "15px",
    display: "flex",
    justifyContent: "center",
    maxWidth: "150px",
    width: "120px",
    alignItems: "center", // Center vertically
  };
  const centerDiv = {
    display: "flex",
    justifyContent: "center", // Centers horizontally
    alignItems: "center", // Centers vertically
    width: "100%",
    height: "100%",
  };

  const rows = (searchTerm ? filteredUserData : userData)?.map((item) => ({
    id: item?.user_id || item?.email || new Date().getTime(), // Use item.email or a timestamp as fallback
    imgUrl: item?.img_url,
    username: item?.username || "Unknown User",
    email: item?.email || "Unknown Email",
    allowed_app_names: item?.allowed_app_names?.length
      ? item?.allowed_app_names //  allowed_app_names if it's an array
      : "No Apps Allowed", // Fallback if no allowed_app_names are present
    deptId: item?.dept_id,
    status: item?.is_active ? "Active" : "Inactive",
    isSuperAdmin: item?.is_superadmin,
    clients: item?.clients || "No Clients Assigned",
    allowed_sows: item?.allowed_sows?.length
      ? item?.allowed_sows //  allowed_app_names if it's an array
      : "No SOWs Allowed",
  }));

  const columns = [
    { field: "id", headerName: "ID", flex: 0.15 },
    {
      field: "imgUrl",
      headerName: "Profile",
      flex: 0.12,
      renderCell: (params) => {
        const profileImage =
          params?.value && params.value.length > 0
            ? `data:image/png;base64,${params.value}`
            : "/profile-image.png";
        return (
          <div style={centerDiv}>
            <Tooltip
              title={params?.value ? "User Profile" : "No Profile Image"}
            >
              <Box
                component="img"
                src={profileImage} // Fallback image
                alt="User Profile"
                sx={{
                  cursor: "pointer",
                  width: 32,
                  height: 32,
                  borderRadius: "50%", // Circular image
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center", //
                  textAlign: "center",
                }}
              />
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "username",
      headerName: "Name/E-mail",
      flex: 0.6,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center", // Centers content vertically
            height: "100%", // Ensures the div fills the cell height
            lineHeight: 1.2,
            whiteSpace: "normal",
          }}
        >
          <span style={{ fontWeight: "bold" }}>{params.row.username}</span>
          <span style={{ fontSize: "0.8rem", color: "#555" }}>
            {params.row.email}
          </span>
        </div>
      ),
    },
    {
      field: "isSuperAdmin",
      headerName: "isSuperAdmin?",
      // headerAlign: "center",
      flex: 0.22,
      minWidth: 100, // Minimum width to handle short values
      renderCell: (params) => (
        <div style={centerDiv}>
          {params?.value === 0 ? (
            <ClearIcon color="error" fontSize="small" />
          ) : (
            <DoneIcon color="success" fontSize="small"></DoneIcon>
          )}
        </div>
      ),
    },

    {
      field: "allowed_app_names",
      headerName: "App Access Levels",
      headerAlign: "center",
      flex: 0.2,
      renderCell: (params) => (
        <Tooltip
          title={
            params?.value && params.value.length > 0 ? (
              <div
                style={{
                  padding: "8px",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "2px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          padding: "4px",
                          textAlign: "left",
                          fontSize: "14px",
                          color: "#555",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        #
                      </th>
                      <th
                        style={{
                          padding: "4px",
                          textAlign: "left",
                          fontSize: "14px",
                          color: "#555",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        App Name
                      </th>
                      <th
                        style={{
                          padding: "4px",
                          textAlign: "left",
                          fontSize: "14px",
                          color: "#555",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        Access Level
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {params.value.split(",").map((appInfo, index) => {
                      const [appName, role] = appInfo.split("-");
                      return (
                        <tr key={index}>
                          <td
                            style={{
                              padding: "4px",
                              fontSize: "14px",
                              color: "#333",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              padding: "4px",
                              fontSize: "14px",
                              color: "#333",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            {appName}
                          </td>
                          <td
                            style={{
                              padding: "4px",
                              fontSize: "14px",
                              color: "#333",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            {role}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              "No Apps Allowed"
            )
          }
          placement="top"
          arrow
          interactive={true.toString()}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <Box
              component="img"
              src={appLogo}
              alt="App logo"
              style={{
                cursor: "pointer",
                width: 34,
                height: 34,
              }}
            />
          </div>
        </Tooltip>
      ),
    },

    {
      field: "status",
      headerName: "Status",
      headerAlign: "center",
      flex: 0.2,
      renderCell: (params) => (
        <div style={centerDiv}>
          <div style={params.value === "Active" ? activeStyle : inactiveStyle}>
            {params.value}
          </div>
        </div>
      ),
    },

    {
      field: "clients",
      headerName: "Clients",
      flex: 0.2,
      headerAlign: "center",
      renderCell: (params) => (
        <Tooltip
          title={
            params?.value && params.value.length > 0 ? (
              <div
                style={{
                  padding: "8px",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "4px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          padding: "4px",
                          textAlign: "left",
                          fontSize: "14px",
                          color: "#555",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        #
                      </th>
                      <th
                        style={{
                          padding: "4px",
                          textAlign: "left",
                          fontSize: "14px",
                          color: "#555",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        Client Name
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {params.value.split(",").map((clientName, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            padding: "4px",
                            fontSize: "14px",
                            color: "#333",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            fontSize: "14px",
                            color: "#333",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          {clientName.trim()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              "No Clients"
            )
          }
          placement="top"
          arrow
          interactive={true.toString()}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Centers horizontally
              alignItems: "center", // Centers vertically
              width: "100%",
              height: "100%",
            }}
          >
            <Box
              component="img"
              src={clientLogo}
              alt="Client logo"
              sx={{
                cursor: "pointer",
                width: 24,
                height: 24,
              }}
            />
          </div>
        </Tooltip>
      ),
    },

    {
      field: "allowed_sows",
      headerName: "SOWs",
      headerAlign: "center",
      flex: 0.2,
      renderCell: (params) => (
        <Tooltip
          title={
            params?.value && params.value.length > 0 ? (
              <div
                style={{
                  padding: "8px",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "2px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          padding: "4px",
                          textAlign: "left",
                          fontSize: "14px",
                          color: "#555",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        #
                      </th>
                      <th
                        style={{
                          padding: "4px",
                          textAlign: "left",
                          fontSize: "14px",
                          color: "#555",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        SoW ID
                      </th>
                      <th
                        style={{
                          padding: "4px",
                          textAlign: "left",
                          fontSize: "14px",
                          color: "#555",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        SoW Title
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {params.value.split(",").map((appInfo, index) => {
                      const [sowID, sowName] = appInfo.split("-");
                      return (
                        <tr key={index}>
                          <td
                            style={{
                              padding: "4px",
                              fontSize: "14px",
                              color: "#333",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              padding: "4px",
                              fontSize: "14px",
                              color: "#333",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            {sowID}
                          </td>
                          <td
                            style={{
                              padding: "4px",
                              fontSize: "14px",
                              color: "#333",
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            {sowName}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              "No Apps Allowed"
            )
          }
          placement="top"
          arrow
          interactive={true.toString()}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <EditNoteIcon
              style={{
                cursor: "pointer",
                fontSize: 34, // Adjust size as needed
                color: "#1976D2", // Optional: customize color
              }}
            />
          </div>
        </Tooltip>
      ),
    },

    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      flex: 0.2,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <IconButton
            color="primary"
            onClick={() => handleEditUserOpen(params.row)}
            aria-label="edit"
          >
            <EditIcon />
          </IconButton>
          <IconButton
            color="error"
            onClick={() => handleDeleteUserClick(params.row.id)}
            aria-label="delete"
          >
            <DeleteIcon />
          </IconButton>
          {isSuperSuperAdmin && params.row.status === "Inactive" && (
            <Tooltip title="Activate User">
              <IconButton
                color="success"
                onClick={() => handleActivateUserClick(params.row.id)}
                aria-label="activate"
              >
                <HowToRegIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <ThemeProvider theme={theme}>
        <Grid className="main-grid-class">
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ mb: 1, p: 1, paddingRight: "0px" }}
            backgroundColor={"#f2f2f2"}
          >
            <Grid item>
              <Button
                onClick={handleGoBack}
                startIcon={<IoArrowBackCircleOutline />}
                sx={{ mr: 1 }}
              >
                Back
              </Button>
              <Typography
                variant="h6"
                component="div"
                sx={{ fontSize: "30px", color: "#1976d2" }}
              >
                User Dashboard
              </Typography>
            </Grid>
            <Grid item>
              <Headerbar onUserRoleNameChange={handleUserRoleNameChange} />
            </Grid>
          </Grid>

          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            className="user-actions"
          >
            <Grid item xs={2} md={6} className="search-box">
              <Grid>
                <i className="fa-solid fa-robot"></i>
                <input
                  placeholder="Hey! What can I help you with?"
                  className="search"
                  autoComplete="off"
                  onChange={onInputChange}
                  autoCapitalize="off"
                  autoFocus="off"
                  type="text"
                  value={searchTerm}
                  name="search"
                />
              </Grid>
              <SearchIcon fontSize="small" />
            </Grid>
            <Grid item xs={1} md={1.5}></Grid>
            {/* <Grid item xs={2} md={1.5} className="add-app-button">
              <Button
                className="add-app-button-btn"
                variant="contained"
                startIcon={<AddCardIcon style={{ color: "#fff" }}></AddCardIcon>}
                // change it to handleassapp
                // onClick={handleAddUserOpen}
              >
                Add App
              </Button>
            </Grid> */}
            {/* <Grid item xs={2} md={1.5} className="add-group-button">
              <Button
                className="add-groups-button-btn"
                variant="contained"
                startIcon={<AddCircleIcon style={{ color: "#fff" }}></AddCircleIcon>}
                // change it to handleassapp
                // onClick={handleAddUserOpen}
              >
                Add Group
              </Button>
            </Grid> */}
            <Grid item xs={2} md={1.5} className="add-user-button">
              <Button
                className="add-user-button-btn"
                variant="contained"
                startIcon={
                  <PersonAddIcon style={{ color: "#fff" }}></PersonAddIcon>
                }
                onClick={handleAddUserOpen}
              >
                Add User
              </Button>
            </Grid>
          </Grid>

          {/* Render AddUserModal */}
          <AddUserModal
            addUserOpen={addUserOpen}
            handleAddUserClose={handleAddUserClose}
            MenuProps={MenuProps}
          />

          {/* Render EditUserModal */}
          <EditUserModal
            editUserOpen={editUserOpen}
            handleEditUserClose={handleEditUserClose}
            clickedUser={clickedUser}
            MenuProps={MenuProps}
          />
          <Grid className="grid-container-main">
            <Grid container className="grid-container">
              <Grid item xs={12} className="data-grid-table">
                <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={10}
                  components={{ Toolbar: GridToolbar }}
                  hideFooterPagination
                  hideFooter
                  className="custom-data-grid"
                  onRowSelectionModelChange={(selection) =>
                    setSelectedRows(selection)
                  }
                  componentsProps={{
                    header: {
                      sx: {
                        "& .MuiDataGrid-columnHeaders": {
                          position: "sticky",
                          top: 0,
                          zIndex: 1000,
                          backgroundColor: "#4b4b4b",
                          color: "#fff",
                          fontWeight: "bold",
                        },
                        "& .MuiDataGrid-columnHeader": {
                          backgroundColor: "#eee",
                          color: "black",
                        },
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <SimpleDialog
            open={deleteModalOpen}
            setOpen={cancelDeleteUser} // This handles closing the modal
            content={
              <form
                onSubmit={(event) => {
                  event.preventDefault();
                  confirmDeleteUser();
                }}
              >
                <Grid
                  container
                  className="logout-main"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Grid item xs={12} style={{ textAlign: "center" }}>
                    <span>Are you sure you want to delete this user?</span>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ textAlign: "center", marginTop: "20px" }}
                  >
                    <Button type="submit" variant="contained" color="error">
                      Yes
                    </Button>
                    <Button
                      onClick={() => cancelDeleteUser()}
                      variant="outlined"
                      style={{ marginLeft: "10px" }}
                    >
                      No
                    </Button>
                  </Grid>
                </Grid>
              </form>
            }
            executeFlag={false}
          />

          <SimpleDialog
            open={activateModalOpen}
            setOpen={cancelActivateUser}
            content={
              <form
                onSubmit={(event) => {
                  event.preventDefault();
                  confirmActivateUser();
                }}
              >
                <Grid
                  container
                  className="logout-main"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Grid item xs={12} style={{ textAlign: "center" }}>
                    <span>Do you really want to activate this user?</span>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ textAlign: "center", marginTop: "20px" }}
                  >
                    <Button type="submit" variant="contained" color="success">
                      Yes
                    </Button>
                    <Button
                      onClick={() => cancelActivateUser()}
                      variant="outlined"
                      style={{ marginLeft: "10px" }}
                    >
                      No
                    </Button>
                  </Grid>
                </Grid>
              </form>
            }
            executeFlag={false}
          />
        </Grid>
      </ThemeProvider>
    </>
  );
};
export default UserControl;
